import CommentsList from './CommentsList';

export default CommentsList;
